import * as storage from '../db/gallery-db.js';
import { getAccountSnapshot, getSogniClientInstance, onAccountUpdate } from '../sogni-client.svelte.js';
import { session, promptStructure, restoreCreativeSession, restart, clearPromptStructure } from './session.svelte.js';
import { studioSettings, studioSettingsUI, applyStudioSettings } from './settings.svelte.js';
import { imageReferences, restoreImageReferences, clearImageReferences } from './image-references.svelte.js';
import { generationRun, restoreGenerationRun } from './generation-run.svelte.js';
import { loadFavoriteVideos, clearLoadedVideos } from './gallery.svelte.js';
import { createSessionPersistenceController } from '../utils/session-persistence-controller.js';

export const sessionPersistence = $state({
  accountId: null, ready: false, isSaving: false, isRecovering: false, savedAt: null,
  restoredSessionId: null, restoredPhase: null,
  error: null, recoveryError: null, sessions: [], storageUsage: null,
  storageQuota: null, persistentStorage: null, savingPaused: false
});

const controller = createSessionPersistenceController({
  state: sessionPersistence, storage, getAccountSnapshot, getSogniClientInstance, onAccountUpdate,
  session, restoreCreativeSession, restart, clearPromptStructure, studioSettingsUI, applyStudioSettings,
  restoreImageReferences, clearImageReferences, generationRun, restoreGenerationRun,
  loadFavoriteVideos, clearLoadedVideos,
  readSnapshot: (accountId) => ({ accountId,
    session: $state.snapshot(session), promptStructure: $state.snapshot(promptStructure),
    settings: $state.snapshot(studioSettings),
    references: $state.snapshot({ assets: imageReferences.assets, guideImage: imageReferences.guideImage,
      guideStrength: imageReferences.guideStrength, revision: imageReferences.revision }),
    generationRun: $state.snapshot(generationRun) })
});

export const { captureCreativeSession, queueSessionSave, flushSessionSave, saveGenerationAttempt, retrySessionSave, refreshSavedProjects, restoreSavedSession, startSessionPersistence, refreshSessionStorage, forgetSavedSession } = controller;
